module.exports = __webpack_public_path__ + "img/pkg.28af4e6b.png";